module.exports = __webpack_public_path__ + "static/media/logo-colored.617aed49.svg";